const e=["1","2","3"],s={size:{type:"enum",className:"rt-r-size",values:e,default:"2",responsive:!0},loading:{type:"boolean",default:!0}};export{s as spinnerPropDefs};
//# sourceMappingURL=spinner.props.js.map
